<div class="header">
	<div class="zk-flex zk-gap-2">
		<div class="zk-flex zk-gap-5 zk-items-center">
			<span class="freud-icon freud-icon-chevron-left" (click)="changeDate('previous')"></span>
			<span class="freud-icon freud-icon-chevron-right" (click)="changeDate('next')"></span>
		</div>
		<span class="active-week">{{ activeName }}</span>
	</div>
	<div class="today">
		<span (click)="showCurrent()">{{ 'CALENDAR.TODAY' | translate }}</span>
	</div>
</div>
